<span
  class="eva-tag"
  [class.eva-tag--soft]="_variant === 'soft'"
  [class.eva-tag--filled]="_variant === 'filled'"
  [class.eva-tag--outlined]="_variant === 'outlined'"
  [class.eva-tag--custom]="!!color"
  [class.eva-tag--primary]="_severity === 'primary' && !color"
  [class.eva-tag--secondary]="_severity === 'secondary' && !color"
  [class.eva-tag--success]="_severity === 'success' && !color"
  [class.eva-tag--warning]="_severity === 'warning' && !color"
  [class.eva-tag--danger]="_severity === 'danger' && !color"
  [class.eva-tag--info]="_severity === 'info' && !color"
  [class.eva-tag--purple]="_severity === 'purple' && !color"
  [class.eva-tag--pink]="_severity === 'pink' && !color"
  [class.eva-tag--teal]="_severity === 'teal' && !color"
  [class.eva-tag--olive]="_severity === 'olive' && !color"
  [class.eva-tag--terracotta]="_severity === 'terracotta' && !color"
  [class.eva-tag--small]="size === 'small'"
  [class.eva-tag--medium]="size === 'medium'"
  [class.eva-tag--large]="size === 'large'"
  [class.eva-tag--rounded]="rounded"
  [style.background-color]="customBgColor"
  [style.color]="customTextColor"
  [style.border-color]="customBorderColor"
>
  <!-- Icon -->
  @if (_icon) {
    @if (isHeroIcon) {
      <ng-icon [name]="_icon" class="eva-tag__icon"></ng-icon>
    } @else {
      <i [class]="_icon" class="eva-tag__icon"></i>
    }
  }

  <!-- Label -->
  @if (_label) {
    <span class="eva-tag__label">{{ _label }}</span>
  }

  <!-- Remove button -->
  @if (removable) {
    <button type="button" class="eva-tag__remove" (click)="handleRemove($event)">
      <ng-icon name="heroXMark"></ng-icon>
    </button>
  }
</span>
